import { createRuntimeRemotesPlugin } from '@fe-toolkit/utility/modern/client'

export default createRuntimeRemotesPlugin({
  remotes: {
    fe_common: {
      publicEnvVar: 'FE_COMMON_REMOTE',
      serverEnvVar: 'SERVER_FE_COMMON_REMOTE',
    },
  },
})
